export const msi = "242689127574";